import { useRouterState } from '@tanstack/react-router';

export function useRouteClubId() {
  const routerState = useRouterState();

  for (const match of routerState.matches) {
    if ('clubId' in match.params) {
      return match.params.clubId;
    }
  }
}
